import { useViewType } from "../utils/ViewState";

const TwoColumnRowConditional = ({children}) => {
    const isDesktop = useViewType();
    return (
        <div className={"flex w-full gap-3" + (isDesktop ? " flex-row sm:flex-row" : " flex-col sm:flex-col")}>
            <div className="w-full sm:w-1/3">
            {children[ isDesktop ? 0 : 1]}
            </div>
            <div className="w-full sm:w-1/3">
            {children[isDesktop ? 1 : 0]}
            </div>
            <div className="w-full sm:w-1/3">
            {children[2]}
            </div>
        </div>
    )
  }
  export default TwoColumnRowConditional;